import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './PortfolioSlider.css';
import { Link } from 'react-router-dom';
import { FaCalendarCheck, FaCity ,FaUsers , FaBus, FaProjectDiagram, FaChalkboardTeacher, FaBook, FaFileVideo,MdVideoCameraFront, FaVideo, FaClinicMedical, FaRobot, FaGraduationCap } from 'react-icons/fa';

const projects = [
  {id: "aibot",
    title: 'Rag Powered AI Chatbot',
    icon: <FaRobot color='lightseagreen' />,
    description: 'Intelligent Rag based chatbot.',
  },
  {
    id: 'hca',
    title: 'Healthcare Appointment System',
    icon: <FaCalendarCheck color='#8f69c8' />,
    description: 'Manage patients appoimtments with ease.',
  },

  {
 id: 'busnotify',
  title: 'Bus Tracking & Alerts',
  icon: <FaBus color='#FF6D00' />,  // Orange for visibility/transport
  description: 'School Bus updates and alerts, including tracking and student registerations.',
  },
  {
    id: 'videoconf',
    title: 'video-conferencing',
    icon: <FaFileVideo color='#c62828' />,
    description: 'High-quality, secure video conferencing.',
  },
    {
   id: 'library',
  title: 'Library Management System',
  icon: <FaBook color='#2E7D32' />,  // Green color for libraries
  description: 'End-to-end digital library solution for schools and libraries.',
  },
    {id: 'schoollms',
  title: 'School LMS',
  icon: <FaChalkboardTeacher color='#1565C0' />,  // Blue for education
  description: 'Comprehensive learning platform for K-12 schools featuring course management, virtual classrooms, and progress analytics.'},
   {id: 'bandapp',
  title: 'Band Mobile Notification App',
  icon: <FaUsers color='#4CAF50' />,  // Blue for government
  description: 'First Nations Band Mobile Notification App for real-time council updates, service requests, and community engagement.'},
    { id: 'scholartrack',
    title: 'ScholarTrack',
    icon: <FaGraduationCap color='#3F51B5' />,  // Academic blue
    description: 'Comprehensive scholarship management platform for students to discover, apply, and track educational funding opportunities.',
  },
];

const PortfolioSlider = () => {
  const sliderRef = useRef(null);
  const navigate = useNavigate();

  const scroll = (direction) => {
    if (!sliderRef.current) return;
    const scrollAmount = 320;
    sliderRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  return (
    <section className="portfolio-slider">
      <h2 className="slider-title"><FaProjectDiagram style={{ marginRight: '10px', color: '#8f69c8', }} />Featured Projects</h2>
      <div className="slider-container">
        <button
          className="slider-arrow left"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            scroll('left');
          }}
          aria-label="Scroll Left"
        >
          ←
        </button>

        <div className="slider-track" ref={sliderRef}>
          {projects.map((project) => (
            <div
              key={project.id}
              className="slider-card"
              onClick={() => navigate(`/projects/${project.id}`)}
            >
              <div className="slider-icon">{project.icon}</div>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
    
            </div>
          ))}
        </div>

        <button
          className="slider-arrow right"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            scroll('right');
          }}
          aria-label="Scroll Right"
        >
          →
        </button>
  
      </div>
      <Link to="/projects" className="all-projects-button">
  View All Projects →
</Link>
    </section>
  );
};

export default PortfolioSlider;
